import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import TheContent from './TheContent'
import TheFooter from './TheFooter'
import TheHeader from './TheHeader'
import TheChatBot from './TheChatBot'

// ACCIONES
// import { loadCargos, loadDepartamentos } from 'src/reducer/actions/empledo'
import {  loadDepartamentos, loadSucursales } from 'src/reducer/actions/empledo'

import { KEY } from 'src/views/search/searcherby/searcherData'

const TheLayout = () => {

    const dispatch = useDispatch();

    // carga datos de departamentos y cargos
    useEffect(() => {
        dispatch(loadDepartamentos({ parametro: KEY.DEPARTAMENTO }));
        dispatch(loadSucursales({ parametro: KEY.SUCURSAL }));

        // dispatch(loadCargos({ parametro: KEY.PUESTO }));
    }, [dispatch]);


    return (
        <div className="App default-layout">
            <TheHeader />
            <TheContent />
            <TheFooter />
            <TheChatBot />
        </div>
    )
}

export default TheLayout

